import {useContext, useEffect, useState} from "react";
import CampGrid from "../Layout/CampGrid";
import Switch from "@mui/material/Switch";
import {Button, FormControlLabel} from "@mui/material";
import AuthContext from "../Services/AuthContext";
import Main from "../Layout/Main";
import {createTableColumn} from "@fluentui/react-components";
import {useNavigate, useParams} from "react-router-dom";

function UserRegistrations() {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const [items, setItems] = useState([]);
    const [archived, setArchived] = useState(false);
    const [camps, setCamps] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (user.token === "") {
            navigate("/");
        }
    }, [user.token, navigate]);

    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            const url = params.id ? `/api/camps/registered/${params.id}` : `/api/camps/registered`;
            await fetch(url, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setItems(data);
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, user.token]);

    useEffect(() => {
        const date = new Date();
        setCamps(items.filter((item) => {
            return archived || new Date(item.end_date) > date
        }));
    }, [items, archived]);
    const actions = <FormControlLabel control={<Switch onChange={() => setArchived(a => !a)} checked={archived} />} label="Archiwalne" />;
    const columns = [
        createTableColumn ({
            columnId: "children",
            renderHeaderCell: () => {
                return "Dziecko";
            },
            renderCell: (item) => {
                return `${item.name} ${item.surname}`
            }
        }),
        createTableColumn ({
            columnId: "reservation",
            renderHeaderCell: () => {
                return "Status";
            },
            renderCell: (item) => {
                if (item.confirmed) {
                    if (item.paid) {
                        return <Button fullWidth variant={'contained'} color={'success'}>Zawarta Umowa</Button>
                    }
                    return <Button fullWidth variant={'contained'} color={'primary'}>Potwierdzony</Button>
                } else {
                    return <Button fullWidth variant={'contained'} color={'warning'}>Rezerwowy</Button>
                }
            }
        }),
    ];
    return (
        <Main title={'Moje Zapisy'} actions={actions}>
            <CampGrid items={camps} additionalColumns={columns} link={'camp_id'}/>
        </Main>
    );
}

export default UserRegistrations;